import type { AxiosError } from 'axios';

export type ListRefreshStatus = 'idle' | 'refreshing' | 'error';

interface HttpErrorShape {
  response?: {
    status?: number;
  };
}

export const isAuthRequiredError = (error: unknown): boolean => {
  const httpError = error as AxiosError | HttpErrorShape;
  return httpError?.response?.status === 401;
};

export const nextRefreshStatusOnError = (): ListRefreshStatus => 'error';
